import { IApi } from '../../api'
import { createAction } from '../types'

export const prefix = 'salesforce'

export const LIST_ACCOUNTS_REQUEST = `${prefix}/LIST_ACCOUNTS_REQUEST`
export const LIST_ACCOUNTS_SUCCESS = `${prefix}/LIST_ACCOUNTS_SUCCESS`
export const LIST_ACCOUNTS_FAILURE = `${prefix}/LIST_ACCOUNTS_FAILURE`

export const listAccounts = createAction(() => ({
  type: [LIST_ACCOUNTS_REQUEST, LIST_ACCOUNTS_SUCCESS, LIST_ACCOUNTS_FAILURE],
  promise: (api: IApi) => api.salesforce.listAccounts(),
}))

export const LIST_INVESTORS_REQUEST = `${prefix}/LIST_INVESTORS_REQUEST`
export const LIST_INVESTORS_SUCCESS = `${prefix}/LIST_INVESTORS_SUCCESS`
export const LIST_INVESTORS_FAILURE = `${prefix}/LIST_INVESTORS_FAILURE`

export const listInvestors = createAction(() => ({
  type: [LIST_INVESTORS_REQUEST, LIST_INVESTORS_SUCCESS, LIST_INVESTORS_FAILURE],
  promise: (api: IApi) => api.salesforce.listInvestors(),
}))

export const DESCRIBE_ACCOUNTS_REQUEST = `${prefix}/DESCRIBE_ACCOUNTS_REQUEST`
export const DESCRIBE_ACCOUNTS_SUCCESS = `${prefix}/DESCRIBE_ACCOUNTS_SUCCESS`
export const DESCRIBE_ACCOUNTS_FAILURE = `${prefix}/DESCRIBE_ACCOUNTS_FAILURE`

export const describeAccount = createAction(() => ({
  type: [DESCRIBE_ACCOUNTS_REQUEST, DESCRIBE_ACCOUNTS_SUCCESS, DESCRIBE_ACCOUNTS_FAILURE],
  promise: (api: IApi) => api.salesforce.describeAccount(),
}))

export const SHOW_ACCOUNT_REQUEST = `${prefix}/SHOW_ACCOUNT_REQUEST`
export const SHOW_ACCOUNT_SUCCESS = `${prefix}/SHOW_ACCOUNT_SUCCESS`
export const SHOW_ACCOUNT_FAILURE = `${prefix}/SHOW_ACCOUNT_FAILURE`

export const showAccount = createAction((uid: string) => ({
  type: [SHOW_ACCOUNT_REQUEST, SHOW_ACCOUNT_SUCCESS, SHOW_ACCOUNT_FAILURE],
  promise: (api: IApi) => api.salesforce.showAccount(uid),
  uid,
}))

export const HIDE_ACCOUNT = `${prefix}/HIDE_ACCOUNT`

export const hideAccount = () => ({
  type: HIDE_ACCOUNT,
})

export const UPDATE_ACCOUNT_REQUEST = `${prefix}/UPDATE_ACCOUNT_REQUEST`
export const UPDATE_ACCOUNT_SUCCESS = `${prefix}/UPDATE_ACCOUNT_SUCCESS`
export const UPDATE_ACCOUNT_FAILURE = `${prefix}/UPDATE_ACCOUNT_FAILURE`

export const updateAccount = createAction((uid: string, data: object) => ({
  type: [UPDATE_ACCOUNT_REQUEST, UPDATE_ACCOUNT_SUCCESS, UPDATE_ACCOUNT_FAILURE],
  promise: (api: IApi) => api.salesforce.updateAccount(uid, data),
  uid,
}))

export const GET_ACCOUNT_TYPE_OPTIONS_REQUEST = `${prefix}/GET_ACCOUNT_TYPE_OPTIONS_REQUEST`
export const GET_ACCOUNT_TYPE_OPTIONS_SUCCESS = `${prefix}/GET_ACCOUNT_TYPE_OPTIONS_SUCCESS`
export const GET_ACCOUNT_TYPE_OPTIONS_FAILURE = `${prefix}/GET_ACCOUNT_TYPE_OPTIONS_FAILURE`

export const getAccountTypeOptions = createAction((category?: string, salesforceId?: string) => ({
  type: [
    GET_ACCOUNT_TYPE_OPTIONS_REQUEST,
    GET_ACCOUNT_TYPE_OPTIONS_SUCCESS,
    GET_ACCOUNT_TYPE_OPTIONS_FAILURE,
  ],
  promise: (api: IApi) => api.salesforce.getAccountTypeOptions({ category, salesforceId }),
  category,
  salesforceId,
}))
